<script lang="ts">
	type Value = null | undefined | string
	export let attributes: { key: string, value: Value }[]

	const remove_parentheticals = (v: Value) => (v || ``).replace(/\([^+)-]+\)/g, ``)
</script>

{#if attributes }
	<div class="attributes">
		{#each attributes as attribute }
			<div class="attribute">
				<div class="label">{ attribute.key }</div>
				<div class="value">{ remove_parentheticals(attribute.value) }</div>
			</div>
		{/each}
	</div>
{/if}

<style>
	.label {
		color: #888;
		text-transform: capitalize;
	}

	.attribute {
		display: block;
		margin: 8px 0;
		border: 0;
		padding: 0;
		font-size: 90%;
		line-height: 1.1;
	}

	.label,
	.value {
		display: inline-block;
		text-align: left;
		font-size: 100%;
	}

	.label:after {
		content: ': ';
	}
</style>
